import { FunctionComponent, useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/AppContainer/messages';
import { translate } from 'containers/services/translate';
import Divider from '@material-ui/core/Divider';
import { get } from 'lodash';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import Inboxe from 'containers/AppContainer/Inboxes/Inboxe';
import {
  BinDiv,
  DrawerContainer,
  DrawerDiv,
} from 'containers/AppContainer/AppBar/style';
import {
  getCountLawyerNotifications,
  getMaxLawyerNotificationTime,
  sortLawyerNotificationsByInboxe,
} from 'containers/AppContainer/AppBar/utils';
export interface InboxesDrawerProps {
  intl: IntlShape;
  isDrawerOpen: boolean;
  loaders: any;
  setIsDrawerOpen: Function;
  listings: any;
  expandRow: any;
  setExpandRow: any;
  inboxesLawyerNotifications: any;
  requestGetInboxesLawyerNotifications: any;
  handleClickNotificationInboxe: Function;
}
const LawyerInboxesDrawer: FunctionComponent<InboxesDrawerProps> = ({
  ...props
}): JSX.Element => {
  const handleToggleDrawer = () => {
    props.setIsDrawerOpen(!props.isDrawerOpen);
  };
  useEffect(() => {
    if (props.isDrawerOpen) {
      props.requestGetInboxesLawyerNotifications();
    }
  }, [props.isDrawerOpen]);
  return (
    <DrawerContainer
      anchor="right"
      open={props.isDrawerOpen}
      onClose={handleToggleDrawer}
    >
      <DrawerDiv>
        <div className="titleConatainer">
          <span className="title">
            {translate({ ...messages.inboxesDrawerTitle }, props)}
          </span>

          <ClearOutlinedIcon
            data-testid={'close-icon'}
            onClick={handleToggleDrawer}
          />
        </div>
        <Divider className="divider" />
        <div className="content">
          <BinDiv>
            {get(props.listings, 'lawyerInboxes', [])
              .filter((el: any) => el.isVisible)
              .map((element: { id: any; title: string }, index: number) => (
                <Inboxe
                  title={element.title}
                  count={getCountLawyerNotifications(
                    props.inboxesLawyerNotifications,
                    element,
                  )}
                  index={index}
                  expandRow={props.expandRow}
                  setExpandRow={props.setExpandRow}
                  maxNotification={getMaxLawyerNotificationTime(
                    props.inboxesLawyerNotifications,
                    element,
                  )}
                  loaders={props.loaders}
                  lawyerNotifications={sortLawyerNotificationsByInboxe(
                    props.inboxesLawyerNotifications,
                    element.id,
                  )}
                  handleClickNotificationInboxe={
                    props.handleClickNotificationInboxe
                  }
                />
              ))}
          </BinDiv>
        </div>
      </DrawerDiv>
    </DrawerContainer>
  );
};

export default injectIntl(LawyerInboxesDrawer);
